<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import router from "@/router";
import { hasCapability, isTeamMember, readAccessSession } from "@/utils/accessControl";

const accessSession = readAccessSession();
const canManageAgents = hasCapability("agents_management", accessSession);
const canViewPromptHistory =
  isTeamMember(accessSession) &&
  hasCapability("prompts_instructions", accessSession);
const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = async (type, data) => {
  if (type === "prompt_history" && !canViewPromptHistory) return;
  if (["edit_agent", "duplicate_agent", "delete_agent"].includes(type) && !canManageAgents) return;
  if (type === "test_agent" && !hasCapability("test_agent", accessSession)) return;
  await uiStore.setModalAction(type);
  uiStore.setModalState(true);
  await uiStore.setModalData(data);

  if (type == 'test_agent') {
    router.push(`/agents-management/${data.id}/test`);
  }
};
</script>

<template>
  <div class="actions-cell">
    <button v-if="canViewPromptHistory" @click="action('prompt_history', props.data)" type="button" class="icon-button" title="Prompt History">
      <LIcon name="history" />
    </button>
    <button v-if="canManageAgents" @click="action('edit_agent', props.data)" type="button" class="icon-button" title="Edit">
      <LIcon name="pencil" />
    </button>
    <button v-if="canManageAgents" @click="action('duplicate_agent', props.data)" type="button" class="icon-button" title="Duplicate">
      <LIcon name="copy" />
    </button>
    <button v-if="canManageAgents" @click="action('delete_agent', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
